import { render, staticRenderFns } from "./moduleItem.vue?vue&type=template&id=2e9074ea"
import script from "./moduleItem.vue?vue&type=script&lang=js"
export * from "./moduleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports